import { Typography, css, styled } from '@mui/material';

export const StyledSmallTypography = styled(Typography)(
  () => css`
    color: #7c8586;
    font-size: 0.75rem;
  `,
);
